import { useQuery } from "@tanstack/react-query";
import { Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { fetchDataImportStatus } from "../../../services/admin/imports/fetch_data_import_status";
import { adminKeys } from "./query_keys";

export type ImportStatus = {
  id: Id;
  accountId: Id;
  createdAt: string;
  importableGroup: string;
  importableType: string;
  state: "created" | "processing" | "completed" | "failed";
  creator: {
    id: Id;
    email: string;
    firstName: string;
    lastName: string;
  };
  csvAttachment: {
    id: Id;
    filename: string;
  };
  summary?: {
    processedRows: { errors: Record<string, string[]>; rowNumber: number }[];
    fileErrors: string[];
  };
};

export const useDataImportStatus = (accountId: Id, id: number, options?: QueryOptions<ImportStatus>) =>
  useQuery(adminKeys.dataImport(accountId, id), () => fetchDataImportStatus({ accountId, id }), options);
